export default "__VITE_ASSET__DX0cMoNI__"